import CustomerHome from '@screens/customer/home'

export default function CustomerHomePage() {
  return <CustomerHome />
}
